import PanelEdit from './PanelEdit';
export default PanelEdit;
